import {AuditActorKind, SYSTEM_USER_ID} from '@sollapay/enums';

import type {AuditActor} from '@sollapay/types';

export const SYSTEM_AUDIT_ACTOR: AuditActor = {
  kind: AuditActorKind.SYSTEM,
  userId: SYSTEM_USER_ID,
  name: 'System'
};

export function firmUserActor(userId: string): AuditActor {
  return {kind: AuditActorKind.FIRM_USER, userId, name: null};
}
